import React from 'react';
import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Tfoot,
  Th,
  Thead,
  Tr,
  Box,
  useColorModeValue
} from '@chakra-ui/react';
import { isMobile } from 'react-device-detect';
import CurrencyData from "./currency-data";
import { MemberProductStatus } from '../models/periodic-product-payment';

interface Props {
  membershipFeesToPay: MemberProductStatus[];
  tableSize: string;
  setTotal?: (total: number) => void;
  variant?: 'default' | 'boxed';
}

function ProductsToPayList(props: Props): JSX.Element {
  const cardBg = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const { variant = 'default' } = props;

  const getMembershipFeesToPay = (): JSX.Element | JSX.Element[] => {
    if (props.membershipFeesToPay.length === 0) {
      return <></>;
    }

    return props.membershipFeesToPay.map((membershipFeeToPay, index) => (
      <Tr key={index}>
        <Td>{isMobile ? membershipFeeToPay.product.shortName : membershipFeeToPay.product.name}</Td>
        <Td isNumeric><CurrencyData value={membershipFeeToPay.remainingPrice}/></Td>
      </Tr>
    ));
  };

  const getTotal = (): number => {
    let total = 0;
    if (props.membershipFeesToPay.length === 0) {
      return total;
    }

    for (const membershipFeeToPay of props.membershipFeesToPay) {
      total += Number(membershipFeeToPay.remainingPrice);
    }

    if (props.setTotal) {
      props.setTotal(total);
    }
    return total;
  };

  const tableComponent = (
    <TableContainer overflowX="-moz-hidden-unscrollable" width={'100%'}>
      <Table size={props.tableSize} width="100%" scrollBehavior="smooth">
        <Thead>
          <Tr>
            <Th textAlign="center">Detalle</Th>
            <Th textAlign="center">Valor</Th>
          </Tr>
        </Thead>
        <Tbody>{getMembershipFeesToPay()}</Tbody>
        <Tfoot>
          <Tr>
            <Th textAlign="start" fontSize="lg" fontWeight="bold">TOTAL</Th>
            <Th isNumeric fontSize="lg" fontWeight="bold">
              <CurrencyData value={getTotal()}/>
            </Th>
          </Tr>
        </Tfoot>
      </Table>
    </TableContainer>
  );

  if (variant === 'boxed') {
    return (
      <Box
        bg={cardBg}
        p={6}
        borderRadius="lg"
        border="1px solid"
        borderColor={borderColor}
        boxShadow="lg"
        width="100%"
      >
        {tableComponent}
      </Box>
    );
  }

  return tableComponent;
}

export default ProductsToPayList;
